import * as XLSX from 'xlsx'
import { getFileExtension } from './fileUpload.utils'

// zip ('PK') — .xlsx; CFB (D0 CF 11 E0) — legacy .xls
const hasZipSignature = (bytes: Uint8Array): boolean => bytes[0] === 0x50 && bytes[1] === 0x4b
const hasCfbSignature = (bytes: Uint8Array): boolean =>
  bytes[0] === 0xd0 && bytes[1] === 0xcf && bytes[2] === 0x11 && bytes[3] === 0xe0

/**
 * Counts data rows in a spreadsheet file (first sheet, header row excluded).
 * Resolves null when the file cannot be parsed as a workbook — never rejects.
 */
export const countFileRows = async (file: File): Promise<number | null> => {
  try {
    const buffer = await file.arrayBuffer()
    const bytes = new Uint8Array(buffer)
    const extension = getFileExtension(file.name)
    // Binary workbook formats must carry their magic bytes — without this guard
    // XLSX.read silently falls back to plain-text parsing of a corrupt file.
    if ((extension === '.xlsx' || extension === '.xls') && !hasZipSignature(bytes) && !hasCfbSignature(bytes)) {
      return null
    }
    const workbook = XLSX.read(buffer, { type: 'array' })
    const sheetName = workbook.SheetNames[0]
    if (!sheetName) return null
    const rows = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
      header: 1,
      blankrows: false,
    })
    return Math.max(0, rows.length - 1)
  } catch {
    return null
  }
}
